import { createSlice } from "@reduxjs/toolkit";

interface IInitialState {
  isOpenModalAddStandard: boolean;
}

const initialState: IInitialState = {
  isOpenModalAddStandard: false,
};

const modalAddStandardSlice = createSlice({
  name: "modalAddStandard",
  initialState,
  reducers: {
    setOpenModalAddStandard: (state, action) => {
      state.isOpenModalAddStandard = action.payload;
    },
  },
});
export const { setOpenModalAddStandard } = modalAddStandardSlice.actions;
export default modalAddStandardSlice.reducer;
